'use strict';

module.exports = function(angularModule) {
  angularModule.directive('deliveryStatusAlert', function(RGSenderConfigService, RGSenderConfigModal, reviewGenService) {
    return {
      template: require("./deliveryStatusAlertDirective.html"),
      restrict: "E",
      controller: function() {
        var vm = this;

        vm.showDeliveryError = false;
        vm.showDeliveryWarning = false;

        RGSenderConfigService.getConfig().then(function(config) {
          vm.showDeliveryError = config.fromAddressVerificationStatus != 'Success';
          vm.showDeliveryWarning = !vm.showDeliveryError && !config.dkimVerified && config.usesCustomDomain;
          vm.config = config;
        });

        vm.configure = function() {
          RGSenderConfigModal.open();
        }
      },
      controllerAs: "vm"
    }
  });
};
